export const resizeImage = (value: number): number => value / 3.0
